import { Survey } from '../../models';
import { Organization } from '../../models';
import { BaseDataService } from './BaseDataService';
import { NotificationService } from '../../services';
import { Question } from '../../interfaces/models';

export class SurveyDataService extends BaseDataService<Survey> {
    constructor(notificationService: NotificationService) {
        super('Survey', 'Surveys', notificationService);
    }

    public getAllByOrganization(organization: Organization): Promise<any> {
        const endpoint = `${this.endpointRoot}/byorganization/${organization.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving surveys.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllForSecondaryReports(organizationId: number | undefined): Promise<any> {
        var endpoint = `${this.endpointRoot}/forSecondaryReports`;
        if (organizationId) {
            endpoint = `${endpoint}/${organizationId}`;
        }
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving surveys.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllByTenant(tenantId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/bytenant/${tenantId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving surveys.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public createCopy(surveyId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/copy/${surveyId}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error copying survey.`;
            this.notificationService.addError(message);
            return;
        });
    }

    public updateQuestionSortOrder(surveyId: number, questions: Question[]): Promise<any> {
        const endpoint = `${this.endpointRoot}/${surveyId}/updateSortOrders`;
        const init = this.buildRequestInit('POST', questions);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification('Question sort order saved successfully');
                return;
            }

            this.notificationService.addError('Error saving question sort order.');
            return;
        });
    }

    public testEmail(surveyId: number, email: string): Promise<any> {
        const endpoint = `${this.endpointRoot}/${surveyId}/testEmail`;
        const init = this.buildRequestInit('POST', { email: email });

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification('Email Sent');
                return;
            }

            this.notificationService.addError('Error saving question sort order.');
            return;
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/api/SurveyData.tsx